/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
import { Flex, FormControl, useToast } from '@chakra-ui/react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { WhiteContainer } from '../../../../components/WhiteContainer'
import { appApi } from '../../../../services/appApi'
import { Body } from '../../../Layouts/Body'
import { useState, useEffect } from 'react'
import { iEtapa, iFeedbackPersonalizadoQuery } from '../../../../interfaces'
import { PropInvalida, ValidarEtapa } from '../../../../Utils/Helper'
import { CreateEtapaBox } from '../../../../components/CreateEtapaBox'
import { ButtonCmp } from '../../../../components/ButtonCmp'
import { ModalPermissoes } from './components/ModalPermissoes'
import { SelectCmp } from '../../../../components/SelectCmp'
import { CheckboxCmp } from '../../../../components/CheckboxCmp'
import { ElementoTooltipCmp } from '../../../../components/ElementoTooltipCmp'
import { InputCmp } from '../../../../components/InputCmp'
import { TextAreaCmp } from '../../../../components/TextareaCmp'
import { SwitchCmp } from '../../../../components/SwitchCmp'
import { ModalGrupos } from './components/ModalGrupos'
import LoadingContainer from '../../../../components/LoadingContainer'
import { ImgSah } from '../../../../components/ImgSah'

interface iPostPesquisa {
  titulo: string
  descricao: string
  respondente: number
  respostaGestor: boolean
  anonima: boolean
  respondenteResponsavelFeedback?: boolean
  pesquisaId?: string
  id?: string
  grupoId?: string
  feedbackId?: string
  permissoesColab?: string[]
  nomeEtapa: string
}

type iParams = {
  trilhaId: string
  processoId: string
  etapaId: string
}

interface iPropsForm {
  pesquisa: iPostPesquisa
  etapa: iEtapa
}

export const CriarPesquisaInterna: React.FC = () => {
  const toast = useToast()
  const { pathname } = useLocation()
  const { trilhaId, etapaId, processoId } = useParams<iParams>()
  const nav = useNavigate()
  const [IsLoading, setIsLoading] = useState(false)
  const [JaCriadoFeedback, setJaCriadoFeedback] = useState('')
  const [Recorrente, setRecorrente] = useState(false)
  const urlPai = processoId ? 'PesquisaInternaEtapaColaborador' : 'PesquisaInternaEtapa'
  const queryParams: iFeedbackPersonalizadoQuery = Object.fromEntries(new URLSearchParams(window.location.search).entries())

  const pesquisaDefault = {
    descricao: '',
    titulo: '',
    respondente: 0,
    respostaGestor: true,
    anonima: false,
    permissoesColab: [],
    nomeEtapa: '',
    respondenteResponsavelFeedback: !!queryParams.feedbackId
  }
  const [Pesquisa, setPesquisa] = useState<iPostPesquisa>(pesquisaDefault)
  const [NomeIsInvalid, setNomeIsInvalid] = useState(false)
  const [NomeEtapaIsInvalid, setNomeEtapaIsInvalid] = useState(false)
  const [GerenciarPermissaoIsOpen, setGerenciarPermissaoIsOpen] = useState(false)
  const [GerenciarGruposIsOpen, setGerenciarGruposIsOpen] = useState(false)
  const [Etapa, setEtapa] = useState<iEtapa>({})
  const [Pesquisas, setPesquisas] = useState<iPostPesquisa[]>([])

  function CriarPesquisa(): void {
    setNomeIsInvalid(false)
    if (Pesquisa.titulo.length < 5) {
      setNomeIsInvalid(true)
      toast({
        title: `O nome ${!queryParams.feedbackId ? 'da pesquisa' : 'do formulário'} deve conter no mínimo 5 caracteres`,
        status: 'error',
        isClosable: false,
        position: 'top-right',
        duration: 4000
      })
      return
    }
    if (!(trilhaId === undefined && etapaId === undefined && processoId === undefined) && Pesquisa.nomeEtapa.length < 5) {
      setNomeEtapaIsInvalid(true)
      toast({
        title: 'O nome da etapa deve conter no mínimo 5 caracteres',
        status: 'error',
        isClosable: false,
        position: 'top-right',
        duration: 4000
      })
      return
    }
    const pesquisa = { ...Pesquisa, grupoId: Pesquisa.grupoId === '' ? undefined : Pesquisa.grupoId, feedbackId: queryParams.feedbackId }
    appApi.post('PesquisaInterna', pesquisa)
      .then(res => {
        if (!!queryParams.fase && !!queryParams.feedbackId && !!queryParams.itemFeedbackId) {
          appApi.patch(`/FeedbackPersonalizado/${queryParams.feedbackId}/ItemFeedback/${res.data}?itemFeedbackId=${queryParams.itemFeedbackId}&fase=${queryParams.fase}`)
            .then(() =>
              nav(`${pathname.replace('Criar', `${res.data as string}`)}/Formularios?fase=${queryParams.fase}`))
            .catch((err) => console.log(err))
        } else {
          nav(`${pathname.replace('Criar', `${res.data as string}`)}/Formularios`)
        }
      })
      .catch(err => console.log(err))
  }

  function CreateEtapaComposta(): void {
    setNomeIsInvalid(false)
    if (Pesquisa.titulo.length < 5) {
      setNomeIsInvalid(true)
      toast({
        title: `O nome ${!queryParams.feedbackId ? 'da pesquisa' : 'do formulário'} deve conter no mínimo 5 caracteres`,
        status: 'error',
        isClosable: false,
        position: 'top-right',
        duration: 4000
      })
      return
    }

    if (Pesquisa.nomeEtapa.length < 5) {
      setNomeEtapaIsInvalid(true)
      toast({
        title: 'O nome da etapa deve conter no mínimo 5 caracteres',
        status: 'error',
        isClosable: false,
        position: 'top-right',
        duration: 4000
      })
      return
    }

    if (!ValidarEtapa(Etapa)) {
      toast({
        title: 'Preencha os campos de etapa',
        status: 'error',
        isClosable: false,
        position: 'top-right',
        duration: 4000
      })
      return
    }

    const form: iPropsForm = {
      pesquisa: { ...Pesquisa, grupoId: Pesquisa.grupoId === '' ? undefined : Pesquisa.grupoId, permissoesColab: Pesquisa.permissoesColab ?? [] },
      etapa: Etapa
    }

    appApi.post(`${urlPai}/${trilhaId ?? processoId ?? ''}`, form)
      .then(res => {
        if (PropInvalida(Pesquisa.pesquisaId)) {
          nav(`${pathname.replace('Criar', `${res.data as string}`)}/Formularios`)
        } else {
          nav(-1)
        }
      })
      .catch(err => console.log(err))
  }

  function getById(): void {
    const param = processoId ? `${processoId}/Etapa/${etapaId as string}` : `${etapaId as string}`
    appApi.get(`${urlPai}/${param}`)
      .then(res => {
        setPesquisa(res.data.pesquisa)
        setEtapa(res.data.etapa)
      })
      .catch(err => console.log(err))
  }

  function getJaCriadoFeedback(): void {
    if (!queryParams.feedbackId || !queryParams.itemFeedbackId || !queryParams.fase) return

    setIsLoading(true)
    appApi.get(`PesquisaInterna/${queryParams.feedbackId}/Item/${queryParams.itemFeedbackId}?fase=${queryParams.fase}`)
      .then(res => {
        setJaCriadoFeedback(res.data)
      })
      .catch(err => console.log(err))
      .finally(() => setIsLoading(false))
  }

  function UpdateEtapaComposta(): void {
    if (Pesquisa.titulo.length < 5) {
      setNomeIsInvalid(true)
      toast({
        title: `O nome ${!queryParams.feedbackId ? 'da pesquisa' : 'do formulário'} deve conter no mínimo 5 caracteres`,
        status: 'error',
        isClosable: false,
        position: 'top-right',
        duration: 4000
      })
      return
    }

    if (!ValidarEtapa(Etapa)) {
      toast({
        title: 'Preencha os campos de etapa',
        status: 'error',
        isClosable: false,
        position: 'top-right',
        duration: 4000
      })
      return
    }

    const form = {
      pesquisa: { ...Pesquisa, grupoId: Pesquisa.grupoId === '' ? undefined : Pesquisa.grupoId },
      etapa: Etapa
    }

    const param = processoId ? `${processoId}/Etapa/${etapaId as string}` : `${etapaId as string}`
    appApi.put(`${urlPai}/${param}`, form)
      .then(() => nav(-1))
      .catch(err => console.log(err))
  }

  function AtualizarEtapa(etapa: iEtapa): void {
    setEtapa(etapa)
  }

  function getPesquisas(): void {
    appApi.get('PesquisaInternaEtapa/Select')
      .then(response => {
        if (response.status === 200) {
          setPesquisas(response.data)
        }
      })
      .catch(err => console.log(err))
  }

  function filtroPesquisa(id: string): void {
    const index = Pesquisas.findIndex(e => e.pesquisaId === id)
    if (index !== -1) {
      const data = {
        descricao: Pesquisas[index].descricao ?? '',
        titulo: Pesquisas[index].titulo ?? '',
        respondente: Pesquisas[index].respondente,
        respostaGestor: Pesquisas[index].respostaGestor,
        anonima: Pesquisas[index].anonima,
        pesquisaId: Pesquisas[index].pesquisaId,
        grupoId: Pesquisas[index].grupoId === '' ? undefined : Pesquisas[index].grupoId,
        nomeEtapa: Pesquisas[index].nomeEtapa,
        respondenteResponsavelFeedback: Pesquisas[index].respondenteResponsavelFeedback
      }
      setPesquisa(data)
    }
  }

  function onSaveGrupo(e: string): void {
    appApi.post(`PesquisaInterna/${Pesquisa.id}/Grupo?grupoId=${e}`)
      .then(res => {
        toast({
          title: 'Grupo atualizado com sucesso!',
          status: 'success',
          isClosable: false,
          position: 'top',
          duration: 4000
        })
        setGerenciarGruposIsOpen(false)
      })
      .catch(err => console.log(err))
  }

  function onSavePermissoes(e: string[]): void {
    appApi.post(`PesquisaInterna/${Pesquisa.id}/Permissoes`, { ids: e })
      .then(res => {
        toast({
          title: 'Permissões atualizadas com sucesso!',
          status: 'success',
          isClosable: false,
          position: 'top',
          duration: 4000
        })
        setGerenciarPermissaoIsOpen(false)
      })
      .catch(err => console.log(err))
  }

  function handleUtilizarPesquisa(val: boolean): void {
    setRecorrente(val)
    if (!val) {
      setPesquisa(pesquisaDefault)
      return
    }
    const data = {
      descricao: Pesquisas[0].descricao ?? '',
      titulo: Pesquisas[0].titulo ?? '',
      respondente: Pesquisas[0].respondente,
      respostaGestor: Pesquisas[0].respostaGestor,
      anonima: Pesquisas[0].anonima,
      pesquisaId: Pesquisas[0].pesquisaId,
      nomeEtapa: Pesquisas[0].nomeEtapa,
      respondenteResponsavelFeedback: Pesquisas[0].respondenteResponsavelFeedback
    }
    setPesquisa(data)
  }

  useEffect(() => {
    if (trilhaId ?? processoId ?? etapaId) {
      if (etapaId) {
        getById()
      }
    }
    getPesquisas()
    getJaCriadoFeedback()
  }, [])

  return (
    <LoadingContainer linhas={32} loading={IsLoading}>
      {JaCriadoFeedback !== ''
        ? <Body>
          <ImgSah center textoPersonalizado='Você já começou a configurar seu formulário, para prosseguir clique no botão abaixo!'>
            <Flex gap={'1rem'}>
              <ButtonCmp VarColor='c6' onClick={() => { nav(`/Feedback/${queryParams.feedbackId}/${queryParams.fase === '0' ? 'Entrada' : 'Desenvolvimento'}`) }}>Voltar para criação</ButtonCmp>
              <ButtonCmp VarColor='Green2' onClick={() => { nav(`${pathname.replace('Criar', `${JaCriadoFeedback}`)}/Formularios?fase=${queryParams.fase}`) }}>Continuar configuração</ButtonCmp>
            </Flex>
          </ImgSah>
        </Body>
        : <Body>
        <ModalPermissoes
          isOpen={GerenciarPermissaoIsOpen}
          onCreate={(e) => {
            setPesquisa({ ...Pesquisa, permissoesColab: e })
          }}
          selecionados={Pesquisa.permissoesColab ?? []}
          onClose={() => setGerenciarPermissaoIsOpen(false)}
          onSave={((etapaId || processoId || trilhaId) && !pathname.includes('Criar')) ? onSavePermissoes : undefined}
        />
        <ModalGrupos
          isOpen={GerenciarGruposIsOpen}
          onCreate={(e) => {
            setPesquisa({ ...Pesquisa, grupoId: e })
          }}
          selecionado={Pesquisa.grupoId ?? ''}
          onClose={() => setGerenciarGruposIsOpen(false)}
          onSave={((etapaId || processoId || trilhaId) && !pathname.includes('Criar')) ? onSaveGrupo : undefined}
        />
        <WhiteContainer margin='1rem 0 0 0'>
          <Flex mb={'1rem'} justifyContent={'space-between'}>
            <h1>{!queryParams.feedbackId ? 'Criar pesquisa interna' : 'Criar formulário'}</h1>
            {!queryParams.feedbackId && <Flex gap={'.75rem'}>
              <ButtonCmp VarColor='Green2' isDisabled={Recorrente} onClick={() => setGerenciarGruposIsOpen(true)}>Grupos (pastas)</ButtonCmp>
              <ButtonCmp VarColor='Rosa' onClick={() => setGerenciarPermissaoIsOpen(true)}>Permissões</ButtonCmp>
            </Flex>}
          </Flex>
          <Flex flexDir={'column'} gap='.75rem' marginBottom={'1rem'}>
            {(trilhaId ?? etapaId ?? processoId) && !pathname.includes('Editar') &&
              <Flex alignItems={'center'}>
                <ElementoTooltipCmp label={Pesquisas.length === 0 ? 'Não existem pesquisas disponíveis para selecionar' : ''}>
                  <CheckboxCmp
                    OnChange={(e) => {
                      handleUtilizarPesquisa(e)
                    }}
                    isDisabled={Pesquisas.length === 0}
                    isChecked={Recorrente}
                  >Utilizar pesquisa existente</CheckboxCmp>
                </ElementoTooltipCmp>
              </Flex>
            }

            {!PropInvalida(Pesquisa.pesquisaId) && (
              <FormControl>
                <SelectCmp
                  title='Selecione uma pesquisa'
                  value={Pesquisa.pesquisaId}
                  OnChange={filtroPesquisa}
                  width={'15rem'}
                  borderColor={'var(--Gray4)'}
                >
                  {
                    Pesquisas?.map((e, i) => {
                      return (
                        <option key={i} value={e.pesquisaId}>{e.titulo}</option>
                      )
                    })
                  }
                </SelectCmp>
              </FormControl>
            )}
            {
              (trilhaId ?? etapaId ?? processoId) && (
                <FormControl>
                  <InputCmp
                  label='Nome da etapa'
                  isInvalid={NomeEtapaIsInvalid}
                  placeholder='Digite o nome da etapa'
                  value={Pesquisa.nomeEtapa}
                  type={'text'}
                  OnChange={(e) => setPesquisa({ ...Pesquisa, nomeEtapa: e })}
                />
              </FormControl>
              )
            }
            <FormControl>
              <InputCmp
                label={`Nome ${!queryParams.feedbackId ? 'da pesquisa' : 'do formulário'}`}
                isDisabled={!PropInvalida(Pesquisa.pesquisaId)}
                isInvalid={NomeIsInvalid}
                placeholder={`Digite o nome ${!queryParams.feedbackId ? 'da pesquisa' : 'do formulário'}`}
                value={Pesquisa.titulo}
                type={'text'}
                OnChange={(e) => setPesquisa({ ...Pesquisa, titulo: e })}
                borderColor={'var(--Gray4)'}
              />
            </FormControl>
            {
              (trilhaId ?? etapaId ?? processoId) && (
                <>
                  <Flex flexDir={'column'}>
                    <FormControl marginBottom={'1rem'}>
                      <SelectCmp
                        title='Para quem será enviada a pesquisa'
                        value={Pesquisa.respondente.toString()}
                        OnChange={(e) => setPesquisa({ ...Pesquisa, respondente: parseInt(e) })}
                        width={'15rem'}
                        isDisabled={pathname.includes('Editar')}
                        borderColor={'var(--Gray4)'}
                      >
                        <option value={'0'}>Gestor</option>
                        <option value={'1'}>Colaborador</option>
                      </SelectCmp>
                    </FormControl>

                    <Flex alignItems={'center'}>
                      <CheckboxCmp
                        OnChange={(e) => setPesquisa({ ...Pesquisa, respostaGestor: !e })}
                        isChecked={!Pesquisa.respostaGestor}
                        isDisabled={!PropInvalida(Pesquisa.pesquisaId)}
                      >
                        Selecione caso não queira disponibilizar as respostas ao gestor
                      </CheckboxCmp>
                    </Flex>
                  </Flex>
                  <CreateEtapaBox
                    EditEtapa={Etapa}
                    ignoreId={etapaId}
                    variant='Etapa'
                    onModelChange={AtualizarEtapa}
                    keyWord='pesquisa interna'
                  />
                </>
              )
            }

            <FormControl>
              <TextAreaCmp label={`Descrição ${!queryParams.feedbackId ? 'da pesquisa' : 'do formulário'}`}
                placeholder={`Digite a descrição ${!queryParams.feedbackId ? 'da pesquisa' : 'do formulário'}`} value={Pesquisa.descricao}
                OnChange={(e) => setPesquisa({ ...Pesquisa, descricao: e })}
                borderColor={'var(--Gray4)'}
                isDisabled={!PropInvalida(Pesquisa.pesquisaId)}
              />
            </FormControl>

            {
              (!queryParams.feedbackId && !pathname.includes('Editar')) && (
                <FormControl as={Flex} justifyContent={'end'}>
                  <SwitchCmp
                    value={Pesquisa.anonima}
                    legendaDireita='Pesquisa anônima'
                    OnChange={() => setPesquisa({ ...Pesquisa, anonima: !Pesquisa.anonima })}
                    isDisabled={!PropInvalida(Pesquisa.pesquisaId)}
                  />
                </FormControl>
              )
            }

            {
              (queryParams.feedbackId) && (
                <CheckboxCmp
                  isChecked={Pesquisa.respondenteResponsavelFeedback}
                  OnChange={(e) => setPesquisa({ ...Pesquisa, respondenteResponsavelFeedback: e })}
                  isDisabled={!PropInvalida(Pesquisa.pesquisaId)}
                >
                  Marque esse campo para que o responsável do colaborador também preencha esse formulário durante a realização do feedback
                </CheckboxCmp>
              )
            }
          </Flex>
          <Flex gap={'.75rem'} justifyContent={'end'}>
            <ButtonCmp
              onClick={() => nav(-1)}
              VarColor='c5'
            >Voltar</ButtonCmp>

            {(etapaId === undefined && (trilhaId ?? processoId)) && (
              <ButtonCmp
                VarColor='Green2'
                onClick={CreateEtapaComposta}
              >Criar etapa</ButtonCmp>
            )}

            {(etapaId) && (
              <ButtonCmp
                VarColor='Green2'
                onClick={UpdateEtapaComposta}
              >Atualizar</ButtonCmp>
            )}

            {(trilhaId === undefined && etapaId === undefined && processoId === undefined) && (
              <ButtonCmp
                VarColor='Green2'
                onClick={CriarPesquisa}
              >Próximo</ButtonCmp>
            )}
          </Flex>
        </WhiteContainer>
      </Body>}
    </LoadingContainer>
  )
}
